var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"section",staticStyle:{"background-color":"#233dff"}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('img',{staticClass:"img-fluid mx-auto d-block",attrs:{"src":"awan/images/404.svg","alt":"halama-tidak-ditemukan","width":"400"}})])])
}]

export { render, staticRenderFns }